<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">Добавить элемент чек-листа</h2>
        <button type="button" class="close" @click="$emit('hide')" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pb-0">
        <form>
          <div class="form-group">
            <label for="name">
              Название элемента чек-листа
              <br><small>Отображается в списке чек-листа</small>
            </label>
            <input v-model="name" type="text" class="form-control" id="name" placeholder="Введите название" v-focus>
          </div>

          <div class="form-group">
            <label for="desc">
              Описание элемента чек-листа
              <br><small>Отображается на экране «подробнее» элемента чек-листа</small>
            </label>
            <textarea
              class="form-control"
              id="desc"
              v-model="description"
              placeholder="Опишите детали действий, на что обратить внимание, что нужно сделать"
              rows="3"
            ></textarea>
          </div>

          <label>Тип элемента чек-листа</label>
          <div class="mb-5">
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="checklist-type-1" class="custom-control-input" v-model="selectedType" value="check">
              <label class="custom-control-label" for="checklist-type-1">Сделано</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="checklist-type-2" class="custom-control-input" v-model="selectedType" value="mark">
              <label class="custom-control-label" for="checklist-type-2">Оценка</label>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <btn-action class="btn btn-primary" @click="save">Сохранить</btn-action>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'

  export default {
    props: ['id', 'task_type_id', 'machine_type_id', 'name_prop', 'description_prop', 'order_number', 'element_type'],
    data () {
      return {
        name: null,
        description: null,
        selectedType: this.element_type ? this.element_type : 'check',
      }
    },
    methods: {
      close (id = this.id) {
        this.$emit('hide', {
          id: id,
          name: this.name,
          description: this.description,
          type: this.selectedType,
        })
      },
      save () {
        let data = {
          task_type_id: this.task_type_id,
          machine_type_id: this.machine_type_id,
          name: this.name,
          description: this.description,
          type: this.selectedType,
          order_number: this.order_number,
        }
        if (this.id === 0) {
          return api.post('checklists', data).then((answer) => {
            this.close(answer.data)
          })
        } else {
          return api.put('checklists/' + this.id, data).then(() => {
            this.close()
          })
        }
      },
    },
    mounted: function () {
      this.name = this.name_prop
      this.description = this.description_prop
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/checklist-modal.vue